export const LABELS = {
	TABLE_SECTION_SR_LABEL: 'Properties table results'
};
